import React from "react";
import Chart from "react-apexcharts";
export default function TableChart({ chartData, graphColor, name }) {
  const options = {
    series: [
      {
        name: name,
        data: chartData,
      },
    ],
    options: {
      chart: {
        height: "10px",
        foreColor: "#fff",
        type: "line",
        zoom: {
          enabled: false,
        },

        categories: {
          color: "#fff",
          fontSize: "15px !important",
        },
        toolbar: {
          show: false,
        },
      },
      colors: [graphColor, "#000", "#000"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "straight",
        width: 2,
      },
      grid: {
        show: false,
      },

      xaxis: {
        type: "category",
        categories: [],
        tickAmount: undefined,
        tickPlacement: "between",
        min: undefined,
        max: undefined,
        range: undefined,
        floating: false,
        decimalsInFloat: undefined,
        overwriteCategories: undefined,
        position: "bottom",
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },

        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        show: false,
        showAlways: false,
      },
      tooltip: {
        enabled: false,
        style: {
          color: "#000",
        },
      },
    },
  };
  return (
    <div>
      <Chart
        options={options.options}
        series={options.series}
        type="line"
        className="customClass"
        width="100px"
        height="80px"
      />
    </div>
  );
}
